import axios from 'axios'

// PRODUCT FILES
export const downloadActivationFileReq = (accountID) => axios.get(`/products/${accountID}/channelProductAssignment/CSV`)

export const uploadActivationFileReq = async (accountID, data, config) =>
  axios.post(`/products/${accountID}/channelProductAssignment/CSV`, data, {
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/csv',
    },
    ...config,
  })

export const downloadAttributesFileReq = (accountID) => axios.get(`/products/${accountID}/productAttributes/CSV`)

export const uploadAttributesFileReq = (accountID, data, config) =>
  axios.post(`/products/${accountID}/productAttributes/CSV`, data, {
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/csv',
    },
    ...config,
  })
// PRODUCT FILES END

// PRODUCT ANALYSIS END
export const productAnalysisGroupingsReq = (accountID) => axios.get(`/productAnalysis/${accountID}/groupings`)

export const productAnalysisReq = (accountID, params) =>
  axios.get(`/productAnalysis/${accountID}`, {
    params,
  })

export const productAnalysisCSVReq = (accountID, params) =>
  axios.get(`/productAnalysis/${accountID}?observable=1`, {
    params,
  })
// PRODUCT ANALYSIS END

// KEYWORD MANAGEMENT
export const productKeyword = (accountID, channelID, productID) =>
  axios.get(`/keywordControl/${accountID}/${channelID}/${productID}`)
// single update
export const changeProductKeyword = (accountID, channelID, productID, data) =>
  axios.patch(`/keywordControl/${accountID}/${channelID}/${productID}`, data)
// bulk update
export const changeProductKeywords = (accountID, channelID, data) =>
  axios.put(`/keywordControl/${accountID}/${channelID}`, data)
// KEYWORD MANAGEMENT END

// CATEGORY MANAGEMENT END
export const productCategory = (accountID, channelID, productID) =>
  axios.get(`/categoryControl/${accountID}/${channelID}/${productID}`)
// single update
export const changeProductCategory = (accountID, channelID, productID, data) =>
  axios.patch(`/categoryControl/${accountID}/${channelID}/${productID}`, data)
// bulk update
export const changeProductCategories = (accountID, channelID, data) =>
  axios.put(`/categoryControl/${accountID}/${channelID}`, data)

export const productCategoryTree = (accountID, channelID) =>
  axios.get(`/categoryControl/${accountID}/${channelID}/categoryTree`)

export const productPossibleCategories = (accountID, channelID) =>
  axios.get(`/categoryControl/${accountID}/${channelID}/possibleCategories`)
// CATEGORY MANAGEMENT END

export const productStatusUpdateReq = (accountID, data) => axios.patch(`/products/${accountID}`, data)

export const getProductsCanBeAdded = (accountID, channelID) =>
  axios.get(`/channels/${accountID}/${channelID}/addProducts2/queryAvailable`)
export const addProductsEan = (accountID, channelID, data, addAsActive) =>
  axios.post(`/channels/${accountID}/${channelID}/addProducts2/add?addAsActive=${addAsActive ? 1 : 0}`, data)
